import Typography from '@mui/material/Typography';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { Target } from 'shared/assets/icons';
import { Button, Sizes } from 'shared/components/ui/button';
import { Icon } from 'shared/components/ui/icon';
import { useOpenCreateGoalDialog } from 'shared/contexts/goal-form';
import { useOpenCreateHabitDialog } from 'shared/contexts/habit-form';

import * as Styled from './empty-message.style';

export type EmptyMessageProps = {
  isGoal?: boolean;
};

const goalLabels = {
  title: 'pages.insights.sections.goals.empty.title',
  description: 'pages.insights.sections.goals.empty.description',
  button: 'pages.insights.sections.goals.empty.button',
};

const habitLabels = {
  title: 'pages.insights.sections.habits.empty.title',
  description: 'pages.insights.sections.habits.empty.description',
  button: 'pages.insights.sections.habits.empty.button',
};

export const EmptyMessage: React.FC<EmptyMessageProps> = ({ isGoal }) => {
  const { t } = useTranslation();
  const openCreateGoalDialog = useOpenCreateGoalDialog();
  const openCreateHabitDialog = useOpenCreateHabitDialog();

  const onCreate = () =>
    isGoal ? openCreateGoalDialog() : openCreateHabitDialog();

  const labels = isGoal ? goalLabels : habitLabels;

  return (
    <Styled.Container>
      <Styled.Content>
        <Styled.Header>
          <Icon icon={Target} />
        </Styled.Header>

        <Styled.Body>
          <Styled.Title>{t(labels.title)}</Styled.Title>
          <Typography variant="overline">{t(labels.description)}</Typography>
        </Styled.Body>

        <Styled.Footer>
          <Button size={Sizes.Small} onClick={onCreate}>
            {t(labels.button)}
          </Button>
        </Styled.Footer>
      </Styled.Content>
    </Styled.Container>
  );
};
